import { rgba } from 'polished';
import React, { FC } from 'react';

import { LeftArrowImage } from 'product_modules/static/images';
import styled from 'types/AppTheme';


interface IBackButtonProps {
  onClick: () => void;
  className?: string;
}

const StyledContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.accentColor};
  width: 52px;
  height: 52px;
  padding: 2px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => rgba(theme.colors.accentColor, 0.2)};
  }
`;

const StyledLeftArrowImage = styled(LeftArrowImage)`
  > path {
    stroke: ${({ theme }) => theme.colors.accentColor};
  }
`;

const BackButton: FC<IBackButtonProps> = ({ onClick, className }) => {
  return (
    <StyledContainer className={className} onClick={onClick}>
      <StyledLeftArrowImage />
    </StyledContainer>
  );
};

export default BackButton;
